import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import httpClient from "api/httpClient";

export default function LoyaltyTransactions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const [snack, setSnack] = useState({ open: false, color: "success", content: "" });
  const openSnack = (color, content) => setSnack({ open: true, color, content });
  const closeSnack = () => setSnack((s) => ({ ...s, open: false }));

  const load = async () => {
    setLoading(true);
    try {
      const res = await httpClient.get("/transactions");
      setItems(res.data?.items || []);
    } catch (e) {
      openSnack("error", e?.response?.data?.message || e.message || "Failed to load transactions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const columns = [
    { Header: "Ref", accessor: "internal_ref" },
    { Header: "Type", accessor: "type" },
    { Header: "Status", accessor: "status" },
    { Header: "Customer", accessor: "customer_id" },
    { Header: "Agent", accessor: "agent_id" },
    { Header: "Points Δ", accessor: "points_delta" },
    { Header: "Pending Δ", accessor: "pending_delta" },
    { Header: "Created", accessor: "created_at" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <MDTypography variant="h4">Transactions</MDTypography>
          <MDButton variant="outlined" color="info" onClick={load}>
            <Icon>refresh</Icon>&nbsp;Refresh
          </MDButton>
        </MDBox>

        <Card>
          <MDBox p={2}>
            <DataTable
              table={{ columns, rows: items }}
              isSorted
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
              canSearch
              loading={loading}
            />
          </MDBox>
        </Card>
      </MDBox>

      <MDSnackbar
        color={snack.color}
        icon="notifications"
        title="Loyalty System"
        content={snack.content}
        open={snack.open}
        onClose={closeSnack}
        close={closeSnack}
        bgWhite
      />
    </DashboardLayout>
  );
}
